import { SentimentString } from "../../../types";

export function convertSentimentToString(
	sentiment: number | undefined,
): SentimentString {
	if (sentiment === undefined) {
		return SentimentString.NoData;
	}

	switch (true) {
		case sentiment < 3:
			return SentimentString.Negative;
		case sentiment > 3:
			return SentimentString.Positive;
		default:
			return SentimentString.Neutral;
	}
}
